import React, { Component } from 'react';
import Nav from './Nav';
import './Page.css';

// props = {
//   user: "the user details"
// }
class NotFound extends Component {
  render() {
    return (
      <div className="page">
        <Nav user={this.props.user}/>
        <header className="spot">
          <figure className="spot-figure spot-emoji">
            <span role="img" aria-label="exploding head">&#x1F92F;</span>
          </figure>
        </header>
        <section className="lead">
          <p>
          404
          </p>
        </section>
        <main className="cont">
        You've reached a URL that is not known to Performing.World.
        </main>
      </div>
    );
  }
}

export default NotFound;
